import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextField, Button, Alert, Box, Typography, Link } from '@mui/material';
import AuthCard from '../../components/AuthCard';
import { useAuth } from '../../auth/AuthContext';
import { formatAuthError } from '../../auth/formatAuthError';

export default function ConfirmPage() {
  const { confirmEmail, resendCode } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [error, setError] = useState('');
  const [resent, setResent] = useState(false);
  const { register, handleSubmit, formState: { isSubmitting } } = useForm();

  const onSubmit = async ({ code }) => {
    setError('');
    try {
      await confirmEmail(email, code);
      navigate('/login');
    } catch (e) {
      setError(formatAuthError(e.message) || 'Invalid code.');
    }
  };

  const handleResend = async () => {
    await resendCode(email);
    setResent(true);
  };

  return (
    <AuthCard title="Check your email" subtitle={`We sent a confirmation code to ${email}`}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {resent && <Alert severity="success" sx={{ mb: 2 }}>Code resent.</Alert>}
      <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField label="Confirmation code" size="small" fullWidth
          {...register('code', { required: true })} />
        <Button type="submit" variant="contained" fullWidth disabled={isSubmitting}
          sx={{ bgcolor: '#3B82F6', '&:hover': { bgcolor: '#2563EB' }, textTransform: 'none', fontWeight: 600 }}>
          {isSubmitting ? 'Confirming…' : 'Confirm'}
        </Button>
      </Box>
      <Typography variant="body2" textAlign="center" mt={2} color="text.secondary">
        Didn't receive it?{' '}
        <Link component="button" onClick={handleResend} sx={{ color: '#3B82F6', fontWeight: 500 }}>
          Resend code
        </Link>
      </Typography>
    </AuthCard>
  );
}
